<template>
	<section>
		<div class="filter-container">
			<el-button>{{ $t("operator.addTo") }}</el-button>
		</div>
		<el-table :data="tableData" border style="width: 100%">
			<el-table-column prop="name_en_long" :label="this.$t('operator.authorizer')"></el-table-column>
			<el-table-column prop="operators" :label="this.$t('operator.permissions')"></el-table-column>
			<el-table-column prop="start_date" :label="this.$t('operator.startingTime')"></el-table-column>
			<el-table-column prop="end_date" :label="this.$t('operator.endTime')"></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button>{{ $t("operator.revise") }}</el-button>
					<el-button type="danger">{{ $t("operator.delete") }}</el-button>
				</template>
			</el-table-column>
		</el-table>
	</section>
</template>

<script>
export default {
	name: "operator",
	data() {
		return {
			tableData: [
				{
					name_en_long: "RAIN.L",
					operators: this.$t("operator.viewPermissions"),
					start_date: "2018-01-01",
					end_date: "2018-12-31",
				},
			],
		};
	},
};
</script>

<style lang="scss">
.filter-container {
	padding-bottom: 10px;
}
</style>
